import React from 'react'
import { Checkbox, Icon } from 'antd'

const CloningSection = ({
  t,
  data,
  isCheckAll,
  onCheckAll,
  onCheckOne,
  isNoLessonSelected,
  isVoiceRequiredMissing
}) => {
  return (
    <div className="clone-cloning-panel">
      <div className="section-head">
        <h3>Lesson Selection</h3>
        <Checkbox onChange={onCheckAll} checked={isCheckAll}>
          {t('labels:Lessons')} ({data.totalLesson})
        </Checkbox>
      </div>

      <div className="status-area">
        {isNoLessonSelected && (
          <div className="status-row">
            <Icon type="warning" className="warningIcon" />
            <label>{t('course:clonning_no_lesson')}</label>
          </div>
        )}
        {isVoiceRequiredMissing && (
          <div className="status-row">
            <Icon type="warning" className="warningIcon" />
            <label>{t('v4:voice_must_be_selected')}</label>
          </div>
        )}
      </div>

      <div className="lessons-list">
        {data.courseLessons.map((lesson, index) => (
          <Checkbox
            onChange={() => onCheckOne(lesson)}
            className="lesson-box"
            key={index}
            checked={lesson.isChecked}
          >
            {t('labels:clone_of')} - {lesson.title}
          </Checkbox>
        ))}
      </div>
    </div>
  )
}

export default CloningSection
